import { render, staticRenderFns } from "./SendCustomNotificationPopup.vue?vue&type=template&id=c20e6df6&scoped=true&"
import script from "./SendCustomNotificationPopup.vue?vue&type=script&lang=ts&"
export * from "./SendCustomNotificationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./SendCustomNotificationPopup.vue?vue&type=style&index=0&id=c20e6df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20e6df6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c20e6df6')) {
      api.createRecord('c20e6df6', component.options)
    } else {
      api.reload('c20e6df6', component.options)
    }
    module.hot.accept("./SendCustomNotificationPopup.vue?vue&type=template&id=c20e6df6&scoped=true&", function () {
      api.rerender('c20e6df6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/SendCustomNotificationPopup.vue"
export default component.exports